<script lang="ts" setup>
import { computed } from "vue";
import { useScreenBreakpoints } from "@/composable/client";
import { useGlobalUser } from "@/stores/globalUser";
import { ContentRatingEnum, MateSearchSorterEnum } from "@/enums";

const props = defineProps<{
  mate: Mate;
}>();

const userStore = useGlobalUser();
const breakpoints = useScreenBreakpoints();
const displayTags = computed(() => {
  if (!props.mate.tag) return [];
  const displayCount = breakpoints.laptop ? 4 : 3;
  return props.mate.tag.split(",").splice(0, displayCount);
});
</script>
<template>
  <div class="flex gap-1 flex-wrap" @click.stop>
    <!-- <RouterLink
      :to="{
        name: 'search',
        query: {
          contentRating: mate.isNsfw
            ? ContentRatingEnum.NSFW
            : ContentRatingEnum.SFW,
        },
      }"
    >
      <span
        :class="{
          'bg-pink-700 text-white': mate.isNsfw,
          'bg-success text-success-content': !mate.isNsfw,
        }"
        class="flex items-center justify-center px-1 h-[1rem] text-[0.625rem] rounded hover:bg-primary hover:text-primary-content"
      >
        {{ mate.isNsfw ? $t("nsfw.nsfw") : $t("nsfw.sfw") }}
      </span>
    </RouterLink> -->
    <RouterLink
      v-if="mate.isRecommended"
      :to="{
        name: 'search',
        query: {
          sort: MateSearchSorterEnum.Recommended,
        },
      }"
    >
      <span
        class="flex items-center justify-center px-1 h-[1rem] text-[0.625rem] rounded hover:bg-primary hover:text-primary-content bg-primary text-primary-content"
      >
        <i class="iconify mingcute--certificate-line" />
      </span>
    </RouterLink>
    <span
      v-if="mate.chatImageMessageCount > 0"
      class="flex items-center justify-center px-1 h-[1rem] text-[0.625rem] bg-primary text-primary-content rounded"
    >
      <i class="iconify mingcute--camera-2-line text-[0.625rem]" />
    </span>
    <RouterLink
      v-for="item in displayTags"
      :key="item"
      :to="{ name: 'search', query: { q: item } }"
    >
      <span
        class="flex items-center justify-center px-1 h-[1rem] text-[0.625rem] text-base-content/50-content rounded hover:bg-primary hover:text-primary-content"
      >
        {{ item }}
      </span>
    </RouterLink>
  </div>
</template>
